import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { Connection } from "../Connection";
import { SearchConsolePropertyDetails } from "./SearchConsolePropertyDetails";
import { SearchConsoleSettingsModal } from "./SearchConsoleSettingsModal";
import searchConsoleLogo from "./search-console-logo.svg";

export const SearchConsoleSettings = (props) => {
    const location = useLocation();
    const userDetails = useSelector(s => s.login.userDetails);
    const [dialogOpen, setDialogOpen] = useState(false);

    const ws = props.currentWorkspace;
    const settings = ws.searchConsoleSettings || {};
    const isOwner = ws.ownerName === userDetails.username;

    // A link from elsewhere in the app ("+ Search Console" on the Monitored URI chart) lands here with the dialog open.
    useEffect(() => {
        if (location.search.includes("selectSearchConsoleOpen=true")) setDialogOpen(true);
    }, [location.search]);

    // The connection is the Analytics one, so its name comes from the same token list rather than
    // from anything stored on the Search Console settings.
    const accountOwnerOf = tokenName =>
        (userDetails.analyticsTokens || []).find(token => token.name === tokenName)?.analyticsAccountOwner;

    return (
        <Connection
            label="Search Console"
            icon={searchConsoleLogo}
            isOwner={isOwner}
            isConnected={Boolean(settings.siteUrl)}
            busyWith={props.busyWith}
            imported={props.imported}
            emptyText="No Search Console connection configured."
            details={<SearchConsolePropertyDetails settings={settings} accountOwner={accountOwnerOf(settings.tokenName)} />}
            onEdit={() => setDialogOpen(true)}
            onRemove={() => props.setSearchConsoleSettings(null)}
            dialog={
                <SearchConsoleSettingsModal
                    workspace={ws}
                    searchConsoleSettings={settings}
                    setSearchConsoleSettings={props.setSearchConsoleSettings}
                    analyticsTokens={userDetails.analyticsTokens || []}
                    isOpen={dialogOpen}
                    toggle={() => setDialogOpen(open => !open)}
                />
            }
        />
    );
};
